<template>
    <zbList v-model="store" class="v-list" v-slot:default="{ item }">
        <div class="item r10" :class="item.itemCls" v-on:click="onInfoClick(item)">
            <div class="bh bstart status" :class="item.statusCls">
                <div class="left bv b1">
                    <div class="fz_34 name">{{item.typeStr}}</div>
                    <div class="fz_24 c_666">{{item.invalidShowTime}}</div>
                    <div class="fz_24 c_666">使用说明：仅限在有限期内使用</div>
                </div>
                <div class="bv tc c_white right bg-contain">
                    <div class="fwb top">
                        <span class="fz_30">￥</span>
                        <span class="fz_50">{{item.price}}</span>
                    </div>
                    <div class="fz_34">兑换</div>
                </div>
            </div>
        </div>
    </zbList>
</template>
<script>
import { ownerList, exchangeOwner } from "@/api/user";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import zbList from "@/components/data/List";
import util from "@/utils/index";
export default {
    mixins: [list, user],
    components: { zbList },
    name: "UserCouponsOwner",
    props: {
        isLogin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 卡券
            store: {
                proxy: {
                    getList: ownerList,
                    disposeItem(item) {
                        let itemCls = "couponsnormal",
                            statusCls = "";
                        // 是否可以兑换
                        const status = item.status,
                            isUse = status == "7";
                        if (!isUse) {
                            itemCls = "couponstaboo";
                        }
                        if (status == "9") {
                            // 已使用
                            statusCls = "use";
                        } else if (status == "-1") {
                            // 已过期
                            statusCls = "overdue";
                        }
                        item.isUse = isUse;
                        item.itemCls = itemCls;
                        item.statusCls = statusCls;
                        item.invalidShowTime = `${util.formattStringTime(
                            item.activeTime
                        )}-${util.formattStringTime(item.invalidTime)}`;
                    }
                }
            }
        };
    },
    methods: {
        onInfoClick(item) {
            if (item.isUse) {
                const me = this;
                me.dialog
                    .confirm({
                        title: "提示",
                        message: "是否兑换该车主卡？"
                    })
                    .then(() => {
                        exchangeOwner(item.id).then(res => {
                            me.storeReLoad();
                            // 获取用户信息
                            me.refreshUser();
                            me.dialog.alert({
                                title: "提示",
                                message: `兑换成功,恭喜您获得${item.price}车主币`
                            });
                        });
                    });
            }
        },
        itemUserLoginend() {
            const me = this;
            me.storeLoad();
        }
    }
};
</script>
<style scoped lang="scss">
.v-list {
    background-color: #f7f8f8;
    padding-top: 12px;
    height: calc(100% - 12px);
    /deep/ .list-item {
        padding: 12px 30px 0 30px;
    }
    .item {
        background-color: #fff;
    }
    .couponsnormal {
        .right {
            background-image: url("~@/assets/imges/user/ownernormal.png");
        }
    }
    .couponstaboo {
        .right {
            background-image: url("~@/assets/imges/user/ownertaboo.png");
        }
    }
    .status {
        @include bg(122px 100px, 360px 30px);
    }
    .use {
        background-image: url("~@/assets/imges/scooter/exchange.png");
    }
    .overdue {
        background-image: url("~@/assets/imges/scooter/overdue.png");
    }
    .item {
        padding-right: 20px;
        .left {
            padding: 40px 31px;
            .name {
                margin-bottom: 51px;
            }
        }
        .right {
            width: 176px;
            height: 180px;
            .top {
                padding: 32px 0;
            }
        }
    }
}
[data-theme="app"] {
    .v-list {
        .use {
            background-image: url("~@/assets/imges/app/scooter/exchange.png");
        }
    }
}
</style>
